import { NotificationManagerFunctions } from './types'

export let NotificationManager: NotificationManagerFunctions

export function setNotificationManager(value: NotificationManagerFunctions) {
  NotificationManager = value
}
